export default function unique<T>(...lists: T[][]): T[] {
  const flattened = ([] as T[]).concat(...lists);
  return Array.from(new Set(flattened));
}
